import { render } from "./VCPresentation.vue?vue&type=template&id=596e2686&scoped=true"
import script from "./VCPresentation.vue?vue&type=script&lang=js"
export * from "./VCPresentation.vue?vue&type=script&lang=js"

import "./VCPresentation.vue?vue&type=style&index=0&id=596e2686&scoped=true&lang=css"

import exportComponent from "/home/user/mydid-badgechecker-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596e2686"]])

export default __exports__